import { TRAIN_AI_STUDIO_TYPES } from '@conversed/shared/src/central/types/studio.type';
import { isRouteAllowedForStudioType } from '@helpers/routeHelpers';
import { useCompanySelector } from './useCompanySelector';

/**
 * Whether the selected company's studio has the Train A.I. review flows. A Voice
 * A.I. studio has the page (a read-only call list) but answers false here, so
 * no link sends it into review work.
 *
 * Gates every link to that page from outside it. Without the gate, a company that
 * cannot reach the page is still offered the button and then bounced to its
 * default page. Returns false while the company is unresolved, so no link renders
 * before its studio type is known.
 */
export const useHasTrainAIAccess = (): boolean => {
  const { selectedCompany } = useCompanySelector();

  return isRouteAllowedForStudioType(
    TRAIN_AI_STUDIO_TYPES,
    selectedCompany?.studioType,
  );
};
